import superagent from 'superagent';

let activeController;

export default function RolloverController(component, direction, spaceRequired) {
    this._component = component;
    this._direction = direction || 'right';
    this._spaceRequired = spaceRequired;
    this._mouseOver = false;
    this._requestId = 0;

    this.getInitialState = function() {
        return { rollover: false };
    };

    this.clearTimers = function() {
        if (this.enterTimer) {
            clearTimeout(this.enterTimer);
            this.enterTimer = undefined;
        }
        if (this.leaveTimer) {
            clearTimeout(this.leaveTimer);
            this.leaveTimer = undefined;
        }
    };

    this.hideRollover = function() {
        this.clearTimers();
        this._mouseOver = false;
        this._requestId += 1;
        this.requestInProgress = false;
        if (activeController === this) {
            activeController = undefined;
        }
        this._component.setState({ rollover: false, data: this._component.state.data });
    };

    this.showRollover = function(apiUrl) {
        if (!this._mouseOver) {
            return;
        }
        if (activeController && activeController !== this) {
            activeController.hideRollover();
        }
        activeController = this;
        if (this._component.state.data) {
            this._component.setState({ rollover: true, data: this._component.state.data });
        } else if (!this.requestInProgress) {
            const requestId = this._requestId;
            this.requestInProgress = true;
            superagent.get(apiUrl, (error, response) => {
                if (error) {
                    console.log('error', error); // TODO
                }
                const result = response && response.body;
                this.requestInProgress = false;
                if (requestId === this._requestId && this._mouseOver && result) {
                    this._component.setState({ rollover: true, data: result.data });
                }
            });
        }
    };

    this._setDirectionInfo = function() {
        this.directionInfo = {
            direction: this._direction
        };
        const element = this._component.refs.element;
        if (element && window) {
            const box = element.getBoundingClientRect();
            const space = {
                above: box.top,
                below: window.innerHeight - box.bottom,
                left: box.left,
                right: window.innerWidth - box.right
            };
            if (this._direction === 'bottom') {
                if (space.below < space.above) {
                    this.directionInfo.direction = 'top';
                }
                if (space.right < space.left && space.right < this._spaceRequired) {
                    this.directionInfo.slideLeft = true;
                }
            } else if (space.below < space.above && space.below < this._spaceRequired) {
                this.directionInfo.slideUp = true;
            }
        }
    };

    this.onMouseEnter = (apiUrl) => {
        this._mouseOver = true;
        this._setDirectionInfo();
        if (activeController && activeController !== this) {
            activeController.hideRollover();
        }
        if (this.leaveTimer) {
            clearTimeout(this.leaveTimer);
            this.leaveTimer = undefined;
            return;
        }
        if (this._component.state.rollover) {
            return;
        }
        this.enterTimer = setTimeout(() => {
            this.showRollover(apiUrl);
            this.enterTimer = undefined;
        }, 500);
    };

    this.onMouseLeave = () => {
        this._mouseOver = false;
        if (this.enterTimer) {
            clearTimeout(this.enterTimer);
            this.enterTimer = undefined;
            return;
        }
        if (this.requestInProgress) {
            return;
        }
        this.leaveTimer = setTimeout(() => {
            this.leaveTimer = undefined;
            if (!this._mouseOver) {
                this.hideRollover();
            }
        }, 500);
    };

    this.componentWillUnmount = () => {
        this.clearTimers();
        this._requestId += 1;
        if (activeController === this) {
            activeController = undefined;
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/RolloverController.js